<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M8 8c.367 0 .68-.13.942-.392.26-.26.391-.575.391-.941 0-.367-.13-.68-.391-.942A1.284 1.284 0 0 0 8 5.333c-.367 0-.68.13-.942.392a1.284 1.284 0 0 0-.391.942c0 .366.13.68.391.941C7.32 7.87 7.633 8 8 8Zm0 4.9c1.356-1.245 2.361-2.375 3.017-3.392.655-1.016.983-1.92.983-2.708 0-1.211-.386-2.203-1.158-2.975-.773-.772-1.72-1.158-2.842-1.158s-2.07.386-2.842 1.158C4.386 4.597 4 5.589 4 6.8c0 .789.328 1.692.983 2.708C5.64 10.525 6.645 11.656 8 12.9Zm0 1.767c-1.789-1.523-3.125-2.937-4.008-4.242C3.108 9.119 2.667 7.911 2.667 6.8c0-1.667.536-2.994 1.608-3.983C5.347 1.827 6.59 1.333 8 1.333s2.653.495 3.725 1.484 1.608 2.316 1.608 3.983c0 1.111-.441 2.32-1.325 3.625-.883 1.305-2.219 2.72-4.008 4.242Z"
        />
    </svg>
</template>

<script setup lang="ts">
type LocationOnIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<LocationOnIconProps>();
</script>
